<template>
	<BaseCmsPage>
		<WebshopCheckoutLayout>
			<template #header>
				<WebshopCheckoutHeader :step="4" />
			</template>
			<template #wcCol2>
				<BaseWebshopCheckout>
					<WebshopStep :step="1" :completed="true" />
					<WebshopStep :step="2" :completed="true" />
					<div class="step-form-cnt step-form3-cnt">
						<div class="step-form-cnt-inner">
							<WebshopStep :step="3" :title="true" />
							<ClientOnly>
								<BaseWebshopPaymentForm class="form step3-form" v-slot="{fields, loading, status, onPaymentUpdate, selectedField}">
									<div class="step3-form-inner payment-options">
										<!--div v-if="status?.success && status?.data?.label_name">
											<div class="global-success"><BaseCmsLabel :code="status.data.label_name" /></div>
										</div-->
										<div v-if="status?.data?.errors">
											<div class="global-error" v-for="error in status.data.errors" :key="error">{{ error.error }}</div>
										</div>
										<template v-for="field in fields" :key="field.value">
											<BaseFormField :item="field" v-slot="{errorMessage}">
												<BaseFormInput :id="field.code" :option-class="['payment-option', {'single': fields?.length == 1}]">
													<template #default="{option, updateFormValue}">
														<input type="radio" :name="field.name" :id="'payment-'+option.id" :value="option.id" :checked="option.selected" @change="updateFormValue" @click="onPaymentUpdate(option)" />
														<label :for="'payment-'+option.id">
															{{option.title}}
															<div v-if="option.description" class="payment-info" v-html="option.description"></div>
														</label>
														<span class="error" v-show="errorMessage" v-html="errorMessage" />
														<BaseThemeWebshopCreditCardInstallmentsForm :field="option" :selected-field="selectedField" :onPaymentUpdate="onPaymentUpdate" />
													</template>
												</BaseFormInput>
											</BaseFormField>
										</template>
										<button class="btn btn-orange noarrow checkout-btn-next-step" type="submit" :class="{'loading': loading}" :disabled="loading"><UiLoader v-if="loading" /><BaseCmsLabel code="next_step" /></button>
									</div>
								</BaseWebshopPaymentForm>
							</ClientOnly>
						</div>
					</div>
					<div class="checkout-steps">
						<WebshopStep :step="4" />
					</div>	
				</BaseWebshopCheckout>
			</template>
		</WebshopCheckoutLayout>
	</BaseCmsPage>
</template>

<style lang="less" scoped>
	.step-form3-cnt{
		margin-top: 21px;
		@media (max-width: @t){margin-top: 14px;}	
	}
	.payment-options{position: relative; display: flex; flex-flow: column; align-items: flex-start;}
	:deep(.payment-option){
		position: relative; display: block; margin-bottom: 12px; width: 100%; border: 1px solid var(--gray); border-radius: 6px; padding: 19px 22px;
		&:last-child{margin-bottom: 0;}
		input[type=radio] + label{
			padding: 0 0 0 32px;
			&:before{border: 1px solid var(--gray); width: 20px; height: 20px; top: -1px;}
			&:after{width: 12px; height: 12px; top: 3px; left: 4px;}
		}
		input[type=radio]:checked + label{
			color: var(--blue);
			&:before{border: 2px solid var(--blue);}
			&:after{width: 12px; height: 12px;}
		}
		&:has(input[type=radio]:checked){
			border-color: var(--blue);
			.payment-info{display: flex;}	
		}
	}
	.payment-info{
		display: flex; flex-flow: column; font-size: 12px; line-height: 1.5; display: none; padding-top: 5px; color: var(--textColor); font-weight: normal;
		:deep(p){padding-bottom: 0;}
	}
	:deep(.wc-card-payment){
		display: flex; flex-flow: column; gap: 10px; margin: 8px 0 0 32px;
		.label{display: block; font-size: 14px;}
	}
</style>